<template>
  <div id="container">
    <div class="main home-pc" :class="{ 'mainvh': list.length < 1}">
      <div class="side">
        <SideBar :types="types" :typeid="dataForm.typeId"
          v-loading="typeLoading" @selectCat="searchProd"></SideBar>
      </div>
      <div class="content" v-loading="listLoading" element-loading-text="作品加载中"
        element-loading-spinner="el-icon-loading">
        <!-- 首页内容展示组件 -->
        <div class="content-mian">
          <!-- 标签选择 -->
          <div class="tags-box" :class="{openMore: tagmore}"
            v-if="list.length > 0 || dataForm.tagName.length > 0 ">
            <div class="title">标签</div>
            <div class="tags">
              <span class="tag-item" v-for="(item,index) in tags"
                :class="{active:isArrayId(item.id, tagId)}" :key="index"
                @click="tagSel(item)">{{ item.tagName || '' }}</span>
            </div>

            <!-- 标签下拉展开按钮 -->
            <!-- <div class="more" @click="tagMore">
              <img src="@/assets/img/tag_more.png" :class="{roteMore: tagmore}"
                alt="" srcset="">
            </div> -->
          </div>
          <!-- 分类结果标题 -->
          <div class="cat-title" v-if="list.length > 0">
            {{ catgName }}
          </div>

          <div class="list" v-if="list.length > 0">

            <div class="list-item" v-for="(item,index) in list" :key="index"
              @click="goDetail(item.id)">
              <div class="cover">
                <!-- <img src="https://picsum.photos/id/396/6000/4000"
                  :alt="item.title" srcset=""> -->
                <!-- <img src="@/assets/img/imgUrl.png" :alt="item.title" srcset=""> -->
                <img :src="item.imgUrl" :alt="item.title" srcset="">
              </div>
              <!-- <div class="name">今日今日今日今日今日今日今日今日今日</div> -->
              <div class="name" :title="item.title">{{ item.title }}</div>
              <div class="type" :title="item.type">{{ item.type }}</div>
            </div>
          </div>

          <div class="empty" v-if="logoVis">
            <div class="img">
              <img src="../../assets/img/caeg_logo.png" alt="" srcset="">
            </div>
            <div class="tiao"><img src="../../assets/img/logo_tiao.png" alt="" srcset=""></div>
            <div class="text">让中国成为世界的舞台<br />让世界成为中国的舞台</div>
          </div>

          <!-- 优秀作品与新入库展示 -->
          <div class="newOne" v-if="logoVis">
            <!-- 新入库 -->
            <div class="new">
              <div class="title">
                <div class="icon">
                  <img src="../../assets/img/new.png" alt="" srcset="">
                </div>
                <div class="text">最新节目入库</div>
                <div class="pagein">
                  <div class="prev" @click="prev('new')">
                    <i class="el-icon-arrow-left"></i>
                  </div>
                  <div class="next" @click="next('new')">
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </div>

              <!-- 列表 -->
              <div class="new-list" v-if="newList.length > 0">
                <div class="list-item" v-for="item in newList" :key="item.id" @click="goDetail(item.videoId)">
                  <div class="cover">
                    <img :src="item.url" :alt="item.worksName" srcset="">
                  </div>
                  <div class="name" :title="item.worksName">{{ item.worksName }}</div>
                  <div class="type" :title="item.typeList">{{ item.typeList }}</div>
                </div>
              </div>
              <div v-else class="newOneEmpty">未查询到新入库节目</div>
            </div>

            <!-- 优秀 -->
            <div class="one">
              <div class="title">
                <div class="icon">
                  <img src="../../assets/img/excellent.png" alt="" srcset="">
                </div>
                <div class="text">优秀节目</div>
                <div class="pagein">
                  <div class="prev" @click="prev('excellent')">
                    <i class="el-icon-arrow-left"></i>
                  </div>
                  <div class="next" @click="next('excellent')">
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </div>

              <!-- 列表 -->
              <div class="new-list" v-if="excellentList.length > 0">
                <div class="list-item" v-for="item in excellentList" :key="item.id" @click="goDetail(item.videoId)">
                  <div class="cover">
                    <img :src="item.url" :alt="item.worksName" srcset="">
                  </div>
                  <div class="name" :title="item.worksName">{{ item.worksName }}</div>
                  <div class="type" :title="item.typeList">{{ item.typeList }}</div>
                </div>
              </div>
              <div v-else class="newOneEmpty">未查询到优秀节目</div>
            </div>
          </div>
          <!-- 暂未搜索到作品 -->
          <div class="empty-nosearch" v-if="list.length < 1 && !logoVis">
            <div>没有搜索到匹配节目，请尝试更换搜索词...</div>
          </div>

          <div class="paging" v-if="list.length > 0">
            <el-pagination background prev-text="上一页"
              :current-page="dataForm.currentPage"
              :page-size="dataForm.pageSize"
             next-text="下一页"
              @current-change="pageChange" layout="prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
          
          <div class="pagin mobile-pagin" v-if="list.length > 0">
            <van-pagination v-model="dataForm.currentPage" @change="pageChange" :total-items="total" :items-per-page="dataForm.pageSize" />
          </div>
        </div>
        <Footer />
      </div>
    </div>
  </div>
</template>
<script>
import { indexMes, perms, indexSearch, newInputList, excellentVideoList } from '@/api/api';
import SideBar from '../../components/SideBar'
import Footer from '../../components/Footer'
export default {
  name: 'PageView',
  components: {
    SideBar,
    Footer
  },
  data () {
    return {
      newList: [], //新入库列表
      excellentList: [],
      excellentPagion:{
        current: 1,
        pages: 1,
        size: 5,
        total: 0
      },
      newPagion:{
        current: 1,
        pages: 1,
        size: 5,
        total: 0
      },
      dataForm: {
        currentPage: 1,
        pageSize: 20,
        searchText: sessionStorage.getItem('searchText') || '',
        typeId: sessionStorage.getItem('typeId') ? sessionStorage.getItem('typeId') : [],
        tagName: sessionStorage.getItem('tagName') ? sessionStorage.getItem('tagName').split(',') : []
      },
      logoVis: this.$route.query.logoVis || false,
      listLoading: false,
      typeLoading: false,
      tagId: sessionStorage.getItem('tagId') ? sessionStorage.getItem('tagId').split(',') : [],
      total: 100,
      tagmore: false,
      catgName: '作品列表',
      list: [],
      tags:[],
      //首页信息 ==》（包含 分类 标签 作品等三个对象信息, 从后台接口 indexMes 调取）
      types: {}
    }
  },
  created () {

    this.perms();

    // 创建时调取主页信息 
    this.indexMes();

    // 调取作品列表
    this.indexSearch();

    // 获取新入库作品
    this.newInputList();

    // 获取 优秀作品、
    this.excellentVideoList();
  },
  mounted: function () {
    this.$root.eventHub.$on("search", this.onSearch);
    this.$root.eventHub.$on("resetForm", this.resetForm);
    this.logoVis = true;
  },
  beforeDestroy () {
    this.$root.eventHub.$off('search')
    this.$root.eventHub.$off('resetForm')
  },
  methods: {

    // 顶级优秀或新作品页
    prev(field) {
      if(field == 'new'){
        if(this.newPagion.current == 1){
          return;
        }
        // 新入库
        this.newPagion.current -= 1;
        this.newInputList();
      } else {
        if(this.excellentPagion.current == 1){
          return;
        }
        // 优秀
        this.excellentPagion.current -= 1;
        this.excellentVideoList()
      }
    },

    // 点击1优秀或新作品下页
    next(field) {
      if(field == 'new'){
        if(this.newPagion.current == this.newPagion.pages){
          return;
        }
        // 新入库
        this.newPagion.current += 1;
        this.newInputList();
      } else {
        if(this.excellentPagion.current == this.excellentPagion.pages){
          return;
        }
        // 优秀
        this.excellentPagion.current += 1;
        this.excellentVideoList()
      }
    },

    // 新入库节目列表
    newInputList() {
      console.log(45)
      newInputList({
        name: this.dataForm.searchText,
        currentPage: this.newPagion.current,
        pageSize: this.newPagion.size,
      }).then(({ data }) => {
        if (data.code == 0 || data.code == 1 || data.code == 200) {
          this.newList = data.obj.records
          this.newPagion = {
            pages: data.obj.pages,
            size: 5,
            current: data.obj.current,
            total: data.obj.total,
          }
        }
      })
    },

    excellentVideoList() {
      console.log(45)
      excellentVideoList({
        name: this.dataForm.searchText,
        currentPage: this.excellentPagion.current,
        pageSize: this.excellentPagion.size,
      }).then(({ data }) => {
        if (data.code == 0 || data.code == 1 || data.code == 200) {
          this.excellentList = data.obj.records
          this.excellentPagion = {
            pages: data.obj.pages,
            current: data.obj.current,
            size: 5,
            total: data.obj.total,
          }
        }
      })
    },

    resetForm () {
      let formObj = {
        currentPage: 1,
        pageSize: 20,
        searchText: '',
        typeId: [],
        tagName: []
      }
      this.logoVis = true;
      this.dataForm = formObj;
      sessionStorage.setItem('searchText','');
      sessionStorage.setItem('typeId',[]);
      sessionStorage.setItem('tagId',[]);
      sessionStorage.setItem('oneID',null);
      sessionStorage.setItem('tagName',[]);
      sessionStorage.setItem('isOpt',false)
      // 调取作品列表
      this.indexSearch();
    },


    
      // 获取用户权限列表
      perms(){
          perms().then(({ data }) => {
              if(data.code == 200 || data.code == 0){
                  sessionStorage.setItem('permissions', JSON.stringify(data.obj || '[]'))
              } else {
                  sessionStorage.setItem('permissions', '[]')
              }
          })
      },


    // 响应后调用查询
    onSearch (data) {
      this.dataForm.currentPage = 1;
      this.dataForm.tagName = [];
      this.tagId = [];
      this.dataForm.searchText = data;
      sessionStorage.setItem('searchText',data);
      sessionStorage.setItem('tagId',[]);
      sessionStorage.setItem('tagName',[]);
      // 调取作品列表
      this.indexSearch();
    },



    // 获取首页信息查询
    indexMes () {
      this.typeLoading = true;
      indexMes({
        ...this.dataForm,
        tagName: this.dataForm.tagName.toString()
      }).then(({ data }) => {
        if (data.code == 0 || data.code == 1 || data.code == 200) {
          this.types = data.t
          this.typeLoading = false;
        }
      })
    },

    indexSearch () {
      this.listLoading = true;
      console.log(this.dataForm.typeId)
      indexSearch({
        ...this.dataForm,
        typeId: this.dataForm.typeId.toString(),
        tagName: this.dataForm.tagName.toString()
      }).then(({ data }) => {
        this.listLoading = false;
        if (data.code == 0 || data.code == 1 || data.code == 200) {
          if(this.dataForm.typeId.length > 0 || this.dataForm.searchText != '' || this.dataForm.tagName.length > 0 && data.t.data.length == 0){
            this.logoVis = false;
          }
          this.list = data.t.data || [];
          this.tags = data.t.tags || [];
          this.total = data.t.total || 0;
        }
      })
    },

    // 选择的分类 params  ==》为子组件（sidebar）传递传递过来的分类
    searchProd (params) {
      this.dataForm.typeId = params;
      this.dataForm.searchText = '';
      this.dataForm.currentPage = 1;
      this.dataForm.tagName = [];
      this.tagId = [];
      sessionStorage.setItem('searchText','');
      sessionStorage.setItem('tagId',[]);
      sessionStorage.setItem('tagName',[]);
      sessionStorage.setItem('typeId',params);
      this.catgName = sessionStorage.getItem('catgName');
      // 调取列表
      this.indexSearch();
    },

    // 选择标签
    tagSel (item) {
      this.dataForm.currentPage = 1;
      console.log(this.tagId.includes(item.id))
      if (this.tagId.includes(item.id)) {
        for(let i = 0; i < this.tagId.length; i++){
          if(this.tagId[i] == item.id){
            this.tagId.splice(i, 1)
            this.dataForm.tagName.splice(i, 1)
          }
        }
        sessionStorage.setItem('tagName',this.dataForm.tagName);
        sessionStorage.setItem('tagId',this.tagId);
      } else {
        this.dataForm.tagName.push(item.tagName)
        this.tagId.push(item.id)
      }
      sessionStorage.setItem('tagName',this.dataForm.tagName);
      sessionStorage.setItem('tagId',this.tagId);
      // 调取列表
      this.indexSearch();
    },

    // 分页改变
    pageChange (e) {
      this.dataForm.currentPage = e;
      // 调取列表
      this.indexSearch();
    },

    // 曲作品详情
    goDetail (id) {
      this.$router.push({
        name: 'detail',
        query: {
          id: id
        }
      })
    },

    // 标签更多
    tagMore () {
      this.tagmore = !this.tagmore
    },
  }
}
</script>
<style   scoped>
.main {
  display: flex;
  width: 100%;
  height: 1170px;
}

.mainvh {
  height:100vh;
}
.side {
  width: 21%;
  margin-bottom: 36px;
  margin-top: 75px;
  overflow-y: scroll;
  background: #fff;
}
.side::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.side::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f5f5;
}
.side::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}
.content {
  width: 80%;
  margin-top: 75px;
  position: relative;
}

.empty {
  width:75%;
  margin: 46px auto 0;
  justify-content: center;
  display: flex;
  align-items: center;
}

.empty-nosearch {
  margin-top: 250px;
  width:100%;
  align-items: center;
  text-align: center;
}

.empty-nosearch div {
  font-size: 56px;
  color:#ccc;
  letter-spacing: 10px;
}

.empty .img{
  width:284px;
  height: 139px;

}

.empty .tiao{
  width:4px;
  height: 170px;
  margin-left:52px;
  margin-right:52px;
}
.empty .tiao img{
  width:100%;
  height:100%;
}

.empty .img img{
  width:100%;
  height: 100%;
}

.empty div.text {
  font-size: 50px;
  font-family: STSongti-SC-Black;
  font-weight: 900;
  color: #182674;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #182675 !important;
}

.content-mian {
  padding: 0 44px;
  position: relative;
}

.tags-box {
  padding-left: 23px;
  padding-right: 45px;
  padding-top:10px;
  padding-bottom: 10px;
  overflow: hidden;
  max-height: 60px;
  background: #ecf2f2;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.16);
  border-radius: 0px 0px 22px 22px;
  display: flex;
  position: relative;
}
.openMore {
  height: auto!important;
}
.tags-box .title {
  width: 92px;
  height: 30px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  text-align: center;
  line-height: 30px;
  color: #fefefe;
  background: #182675;
  border-radius: 4px;
  margin-right: 13px;
}
.tags-box .tags {
  flex: 9;
}
.tags-box .tags .tag-item {
  display: flex;
  padding: 2px;
  font-size: 18px;
  margin-right: 16px;
  border: 2px solid transparent;
  display: inline-block;
  cursor: pointer;
  color: #999999;
}
.tags-box .tags .active {
  padding: 2px;
  border-radius: 4px;
  color: #ff76ba;
  border: 2px solid #ff76ba;
}
.tags-box .more {
  margin-left: auto;
  position: absolute;
  right: 45px;
  bottom: 18px;
  padding-top: 70px;
}
.tags-box .roteMore {
  transform: rotate(-180deg);
}
.tags-box .more img {
  width: 18px;
  height: 18px;
}

/* 作品搜索标题 */
.cat-title {
  margin-top: 10px;
  font-size: 24px;
  padding-bottom: 4px;
  font-family: STSongti-SC-Bold, STSongti-SC;
  color: #5d5d5d;
  border-bottom: 2px solid #cfcfcf;
}

/* 列表 */
.list {
  margin-top: 9px;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}
.list .list-item {
  width: 20%;
  cursor: pointer;
  height: 25%;
}
.list-item .cover {
  margin-left: 10px;
  height: 148px;
  margin-bottom: 5px;
}
.list-item .name {
  margin-left: 10px;
}
.list-item .type {
  margin-left: 10px;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #201d1d;
}
.list-item .cover img {
  width: 100%;
  height: 100%;
}
.list-item .name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  color: #201d1d;
}
/* .list {
  margin-top: 9px;
  display: flex;
  flex-wrap: wrap;
} */

/* .list .list-item {
  width: 20%;
  cursor: pointer;
  margin-bottom: 28px;
}
.list-item .cover {
  width: 257px;
  height: 182px;
  margin-bottom: 14px;
}

.list-item .cover img {
  width: 100%;
  height: 100%;
}
.list-item .cover .name {
  width: 100%;
  margin-bottom: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  color: #201d1d;
} */

.list-item .cover img {
    width:100%;
    height: 100%;
}
.list-item .name {
    margin-bottom:8px;
    overflow: hidden;
        width: 215px;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-size:16px;
    color:#201D1D
}
/* 分页 */
.paging {
  text-align: center;
  padding-bottom: 50px;
  margin-top: 20px;
}
>>> .el-pagination.is-background .btn-prev, >>> .el-pagination.is-background .btn-next {
  min-width:50px!important;
}
>>> .el-pagination.is-background .btn-prev span, >>> .el-pagination.is-background .btn-next span {
  min-width:50px!important;
}
>>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #182675 !important;
}

>>> .paging .el-pager li:hover {
  color: #606266 !important;
}
>>> .el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  color: #ffffff !important;
}
/* .btn-prev:hover, */
>>> .btn-prev:hover {
  background-color: #182675 !important;
  color: #ffffff !important;
}
>>> .btn-next :hover {
  background-color: #182675 !important;
  color: #ffffff !important;
}

/* IE 浏览器 */
.scrollbar {
  /*三角箭头的颜色*/
  scrollbar-arrow-color: #fff;
  /*滚动条滑块按钮的颜色*/
  scrollbar-face-color: #0099dd;
  /*滚动条整体颜色*/
  scrollbar-highlight-color: #0099dd;
  /*滚动条阴影*/
  scrollbar-shadow-color: #0099dd;
  /*滚动条轨道颜色*/
  scrollbar-track-color: #0066ff;
  /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
  scrollbar-3dlight-color: #0099dd;
  /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
  scrollbar-darkshadow-color: #0099dd;
  /*滚动条基准颜色*/
  scrollbar-base-color: #0099dd;
}

/* chrome & safari 浏览器 */
/*滚动条整体部分,必须要设置*/
.scrollbar::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #0099ff;
}
/*滚动条的轨道*/
.scrollbar::-webkit-scrollbar-track {
  background-color: #0099ff;
}
/*滚动条的滑块按钮*/
.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 0;
  background-color: #f00;
  box-shadow: inset 0 0 5px #f00;
}
/*滚动条的上下两端的按钮*/
.scrollbar::-webkit-scrollbar-button {
  height: 0;
  background-color: #0099ff;
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .empty {
  margin-top: 46px;
  width:100%;
  justify-content: center;
  display: flex;
  align-items: center;
}

.empty .img{
  width:128px;
  height: 61px;

}

.empty .tiao{
  width:5px;
  height: 87px;
  margin-left:52px;
  margin-right:52px;
}
.empty .tiao img{
  width:100%;
  height:100%;
}

.empty .img img{
  width:100%;
  height: 100%;
}

.empty div.text {
  font-size: 25px;
  font-family: STSongti-SC-Black;
  font-weight: 900;
  color: #182674;
}
}

@media screen and (min-width: 1366px) and (max-width: 1440px) {
  .empty {
  margin-top: 46px;
  width:100%;
  justify-content: center;
  display: flex;
  align-items: center;
}

.empty .img{
  width:228px;
  height: 111px;

}

.empty .tiao{
  width:5px;
  height: 137px;
  margin-left:52px;
  margin-right:52px;
}
.empty .tiao img{
  width:100%;
  height:100%;
}

.empty .img img{
  width:100%;
  height: 100%;
}

.empty div.text {
  font-size: 50px;
  font-family: STSongti-SC-Black;
  font-weight: 900;
  color: #182674;
}
}

/* 新入库与优秀作品 */
.newOne {
  margin-top:30px;
}

.newOne .title{
  display: flex;
  align-items: center;
}

.newOne .new .title  .icon {
  width: 54px;
  height: 30px;
  margin-right:6px;
} 


.newOne .one .title .icon {
  width: 42px;
  height: 40px;
  margin-right:18px;
} 

.newOne .title .icon img{
  width:100%;
  height:100%;
}

.newOne .one {
  margin-top:  20px;
}

.newOne .title .text{
  font-size: 28px;
  font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
  font-weight: normal;
  font-weight: 700;
  color: #000000;
}

.new-list {
  display: flex;
  flex-wrap: wrap;
  margin-top:24px;
  grid-template-columns: repeat(auto-fill, 18%);
  grid-gap: 2%;
}
.new-list .list-item {
  width:18%;
}
.new-list .list-item .cover {
  width:100%;
  margin:0;
  border-radius: 8%;
  height:142px;
}

.new-list .list-item .cover img{
  width:100%;
  height:100%;
  border-radius: 8px;
}

.new-list .list-item .name {
  font-size: 18px;
  font-weight: 400;
  width: 180px;
  margin:0;
  margin-top:14px;
  color: #181415;
}

.new-list .list-item .type {
  margin-left:0 ;
  margin-bottom: 0;
  margin-top: 0;
}

.newOneEmpty {
  margin: 20px auto;
  text-align: center;
  font-size:28px;
  color:#888;
  letter-spacing: 10px;
}

.pagein {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.pagein div {
  width: 45px;
  height: 30px;
  background:#cfcfcf;
  cursor: pointer;
  text-align: center;
  line-height: 30px;
  opacity: 0.6;
}
.pagein .prev {
  margin-right:10px;
  
  border-radius: 8px 0px 0px 8px;
}
.pagein .next {
  border-radius: 0 8px 8px 0;
}
.pagein div i {
  color: #fff;
  font-size: 20px;
  margin-top:5px;
}
</style>




// WEBPACK FOOTER //
// src/view/home/homePage.vue